import React from "react";
import { useSelector } from "react-redux";

import TopNavBarSpan from "./TopNavBarSpan";
import TopSubNavBar from "./TopSubNavBar";

const TopNavBar = ({
  topTab,
  setTopTab,
  worksheetTab,
  setWorksheetTab,
  tabList,
}) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      {user.logo_img && (
        <img
          src={user.logo_img}
          alt="logo"
          style={{
            maxWidth: "300px",
            maxHeight: "40px",
            objectFit: "contain",
            position: "absolute",
            top: "40px",
            left: "calc(50% - 700px)",
            transform: "translateY(-50%)",
          }}
        />
      )}
      {/* 상단 바 */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "3.5vw",
          borderBottom: "1px solid #EBEBEB",
          fontSize: "18px",
          height: "80px",
          backgroundColor: "#FFF",
        }}
      >
        {tabList.map((tab) => (
          <TopNavBarSpan
            topTab={topTab}
            setTopTab={setTopTab}
            worksheetTabName={tab.subTabList[0]?.name || ""}
            setWorksheetTab={setWorksheetTab}
            tabName={tab.name}
            tabText={tab.text}
          />
        ))}
      </div>

      <TopSubNavBar
        topTab={topTab}
        worksheetTab={worksheetTab}
        setWorksheetTab={setWorksheetTab}
        tabList={tabList}
      />
    </div>
  );
};

export default TopNavBar;
